export const appColors = {
  lightColor: "#E4EFE7",
  darkColor: "#00C1A3",
  baseColor: "#fff",
  defaultBorderColor: "#D1D5DB",
  greenBorderColor: "#138808",
  textColor: "#fff",
  deleteButtonColor: "#FFECEC",
};
